var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3249 13.4682C23.3249 13.4682 22.7819 20.2032 22.4669 23.0402C22.3169 24.3952 21.4799 25.1892 20.1089 25.2142C17.4999 25.2612 14.8879 25.2642 12.2799 25.2092C10.9609 25.1822 10.1379 24.3782 9.9909 23.0472C9.6739 20.1852 9.1339 13.4682 9.1339 13.4682",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7082 10.2397H7.7502",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4406 10.2397C20.6556 10.2397 19.9796 9.6847 19.8256 8.9157L19.5826 7.6997C19.4326 7.1387 18.9246 6.7507 18.3456 6.7507H14.1126C13.5336 6.7507 13.0256 7.1387 12.8756 7.6997L12.6326 8.9157C12.4786 9.6847 11.8026 10.2397 11.0176 10.2397",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteScan);
export default __webpack_public_path__ + "static/media/delete-scan.bec5db21743f66b39abbe36220df525c.svg";
export { ForwardRef as ReactComponent };